import React, { createContext, useState, useEffect, useContext } from 'react';
import { login as apiLogin, logout as apiLogout, setTokenExpirationHandler } from '../services/api';
import { message } from 'antd';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 处理 token 过期
  const handleTokenExpiration = () => {
    setUser(null);
    message.error('登录已过期，请重新登录');
  };

  useEffect(() => {
    // 设置 token 过期处理器
    setTokenExpirationHandler(handleTokenExpiration);

    // 检查用户是否已登录 - 简化验证，只检查token是否存在
    const checkLoggedIn = async () => {
      const token = localStorage.getItem('token');
      const cachedUser = localStorage.getItem('user');
      
      if (token && cachedUser) {
        try {
          const userData = JSON.parse(cachedUser);
          setUser(userData);
        } catch (e) {
          // 解析失败时清除缓存
          localStorage.removeItem('user');
        }
      }
      setLoading(false);
    };

    checkLoggedIn();
  }, []);

  const login = async (username, password) => {
    try {
      setError(null);
      const response = await apiLogin(username, password);
      
      const { token, _id, username: responseUsername, isAdmin } = response.data;
      
      // 保存 token
      localStorage.setItem('token', token);
      
      // 设置用户信息
      const userData = {
        _id,
        username: responseUsername,
        isAdmin
      };
      setUser(userData);
      // 缓存用户信息，便于刷新后立即恢复登录态
      try { localStorage.setItem('user', JSON.stringify(userData)); } catch (e) {}
      
      return userData;
    } catch (err) {
      const errorMessage = err.response?.data?.message || '登录失败';
      setError(errorMessage);
      message.error(errorMessage);
      throw err;
    }
  };

  const logout = async () => {
    try {
      await apiLogout();
    } catch (err) {
      console.error('登出错误:', err);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        error,
        login,
        logout,
        isAuthenticated: !!user,
        isAdmin: user?.isAdmin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext); 